import { useForm } from 'vee-validate';

export default defineNuxtPlugin(() => {
  return {
    provide: {
      form: useForm,
    },
  };
});
